var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "13",
        height: "12",
        viewBox: "0 0 13 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d:
            "M12.9839 6.46154L1.75472 6.46154L6.56722 11.3077L5.95855 12L0.000220728 6L5.95855 -1.29317e-06L6.56722 0.692307L1.75472 5.53846L12.9839 5.53846L12.9839 6.46154Z",
          fill: "#00A5EE",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }